import React, { type FC } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { Checkbox } from 'reactApp/ui/DataListItemCommonComponents/Checkbox/Checkbox';
import { Download } from 'reactApp/ui/DataListItemCommonComponents/Download/Download';
import { Favorite } from 'reactApp/ui/DataListItemCommonComponents/Favorite/Favorite';
import { Date } from 'reactApp/ui/DataListItemRow/components/Date/Date';
import { ItemName } from 'reactApp/ui/DataListItemRow/components/ItemName/ItemName';
import { Size } from 'reactApp/ui/DataListItemRow/components/Size/Size';
import { TableColumn } from 'reactApp/ui/DataListItemRow/components/TableColumn/TableColumn';
import type { VigboAlbumItemProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';
import { FilePic } from 'reactApp/ui/FilePic/FilePic';
import { useCompactView } from 'reactApp/ui/VirtualList/VirtualList.hooks';

import styles from '../../DataListItemRow.new.css';

export const VigboAlbumsItem: FC<VigboAlbumItemProps> = (props) => {
    const {
        id,
        storage,
        denyDoAction,
        isFolder,
        renameAvailable,
        thumbUrl,
        isVirus,
        kind,
        isPublic,
        name,
        size,
        mtime,
        author,
        ext,
        favoritesAvailable,
        isAutoDelete,
        publicExpires,
        isSelected,
        isInFavorites,
        onCheckboxClick,
        onFavorites,
        onDownload,
    } = props;

    const isCompact = useCompactView();

    return (
        <>
            <TableColumn>
                <Checkbox
                    className={styles.check}
                    onCheckboxClick={onCheckboxClick}
                    isSelected={isSelected}
                    isDisabled={denyDoAction}
                    viewType={EViewMode.list}
                />
                <FilePic
                    isFolder={isFolder}
                    thumbUrl={thumbUrl}
                    kind={kind}
                    isVirus={isVirus}
                    ext={ext || ''}
                    author={author}
                    isAutoDelete={isAutoDelete}
                    publicExpires={publicExpires}
                    isPublic={isPublic}
                />
            </TableColumn>

            {isCompact ? (
                <TableColumn width="100%" overflow="hidden">
                    <div className={styles.nameWrapper}>
                        <ItemName name={name} ext={ext || ''} loading={denyDoAction} id={id} isRenameAvailable={renameAvailable} />
                        <span className={styles.responsiveDateWrapper}>
                            <Size size={size} isInline />
                            {!!mtime && <>&nbsp;•&nbsp;</>}
                            <Date date={mtime} className={styles.date} />
                        </span>
                    </div>
                </TableColumn>
            ) : (
                <>
                    <TableColumn width="100%" overflow="hidden">
                        <ItemName name={name} ext={ext || ''} loading={denyDoAction} id={id} isRenameAvailable={renameAvailable} />
                    </TableColumn>
                    <TableColumn flexBasis={132} flexShrink={0} justifyContent="flex-end">
                        <Date date={mtime} />
                    </TableColumn>
                    <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                        <Size size={size} />
                    </TableColumn>
                </>
            )}

            <TableColumn flexBasis={100} flexShrink={0} justifyContent="flex-end" gap={20}>
                {!denyDoAction && (
                    <Favorite
                        className={styles.favoriteAction}
                        isAvailable={favoritesAvailable}
                        isFavorite={isInFavorites}
                        onClick={onFavorites}
                        viewType={EViewMode.list}
                    />
                )}
                {!denyDoAction && (
                    <Download
                        onClick={onDownload}
                        ext={isFolder ? 'zip' : ext}
                        size={size}
                        id={id}
                        storage={storage}
                        viewType={EViewMode.list}
                    />
                )}
            </TableColumn>
        </>
    );
};
